import React, { type ComponentPropsWithoutRef } from 'react';
import { styled } from '@compiled/react';
import Heading from '@atlaskit/heading';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { useIntlV2 as useIntl } from '@atlassian/jira-intl/src/v2/use-intl.tsx';
import { IssuesTrendSummary } from '../../../common/ui/trend-summary/index.tsx';
import messages from './messages.tsx';
import type { Props } from './types.tsx';

export const SelectionDetail = ({
	medianIssuesPerDeployment,
	wholePeriodMedian,
	prodDataState,
}: Props) => {
	const { formatMessage, formatNumber } = useIntl();

	return (
		<>
			{medianIssuesPerDeployment !== null && (
				<>
					<PrimaryValue>{formatNumber(medianIssuesPerDeployment)}</PrimaryValue>
					<WeeklyProductionDeployments>
						{formatMessage(messages.medianIssuesPerProductionDeployment)}
					</WeeklyProductionDeployments>
				</>
			)}
			<IssuesTrendSummary
				weekCount={medianIssuesPerDeployment ?? 0}
				wholePeriodStatistic={wholePeriodMedian ?? 0}
				prodDataState={prodDataState}
			/>
		</>
	);
};

const PrimaryValue = (props: ComponentPropsWithoutRef<typeof PrimaryValueComponent>) => (
	<Heading size="medium">
		<PrimaryValueComponent {...props} />
	</Heading>
);

const WeeklyProductionDeployments = (
	props: ComponentPropsWithoutRef<typeof WeeklyProductionDeploymentsComponent>,
) => (
	<Heading size="xxsmall" as="div">
		<WeeklyProductionDeploymentsComponent {...props} />
	</Heading>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PrimaryValueComponent = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text', colors.N500),
	marginTop: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const WeeklyProductionDeploymentsComponent = styled.p({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtle', colors.N300),
	marginBottom: token('space.100', '8px'),
	marginTop: 0,
});
